import { COMMON } from "../../util/localizations"

const TRANSLATIONS = {
    en: {
        addConnection: 'Create a connection to "{0}"',
        cancel: COMMON.en.cancel,
        connect: 'Connect',
        connectTo: 'Connection',
        instructions: "This creates a new connection. You'll be able to remove the connection later if you'd like.",
        noMoreConnections: 'There are no eligible nodes to connect to.'
    }
}

export default TRANSLATIONS